import React, { createRef, type FC } from 'react'
import { Box, LinearProgress, type SxProps, type Theme } from '@mui/material'

import { ConnectwareError, Translation } from '../../../domain'

import { createClickerHandler, readFirstFileAsText } from '..'
import { useAsyncCallback } from '../Callback'
import { AddIcon, AlertTriangleFilledIcon, Button, HiddenRawFileUpload } from '../common'
import { FormattedTranslation } from '../Internationalization'
import { useAppUsecase } from '../State'

const wrapperStyle: SxProps<Theme> = { display: 'flex' }
const addStyle: SxProps<Theme> = { ml: 'auto' }

export const Add: FC = () => {
    const ref = createRef<HTMLInputElement>()

    const addCertificate = useAppUsecase('addCertificateUsecase')

    const [onChange, loading, value] = useAsyncCallback(
        (files: readonly File[]) => readFirstFileAsText(files).then((content) => (content ? addCertificate.add(content) : Promise.resolve())),
        [addCertificate]
    )

    return (
        <Box sx={wrapperStyle} className="add-certificate">
            <Button
                sx={addStyle}
                size="large"
                variant="primary"
                title={ConnectwareError.is(value) ? value.message : undefined}
                startIcon={<AddIcon />}
                endIcon={ConnectwareError.is(value) && <AlertTriangleFilledIcon data-testid="new-certificate-error" color="error" />}
                onClick={createClickerHandler(ref)}
            >
                <FormattedTranslation id={Translation.ADD_CERTIFICATE} />
                {loading && <LinearProgress />}
            </Button>
            <HiddenRawFileUpload ref={ref} onChange={onChange} />
        </Box>
    )
}
